import { FC } from 'react';

interface ITicketConfirmationHeaderProps{}

const TicketConfirmationHeader: FC<ITicketConfirmationHeaderProps> = ()=>{
  return null;
}

export default TicketConfirmationHeader;